/**
 * Legal pages translations
 * Body content stays in English (international standard for legal documents).
 * Titles and UI chrome are translated.
 */
import type { TranslationDict } from '../types';

export const legal: TranslationDict = {
  privacy: {
    title: {
      en: 'Privacy Policy',
      'zh-CN': '隐私政策',
      ja: 'プライバシーポリシー',
    },
  },
  terms: {
    title: {
      en: 'Terms of Service',
      'zh-CN': '服务条款',
      ja: '利用規約',
    },
  },
  childSafety: {
    title: {
      en: 'Child Safety Policy',
      'zh-CN': '儿童安全政策',
      ja: '子どもの安全ポリシー',
    },
  },
  suspended: {
    title: {
      en: 'Account Suspension & Appeals',
      'zh-CN': '账号封禁与申诉',
      ja: 'アカウント停止と異議申し立て',
    },
  },
  disclaimer: {
    title: {
      en: 'Disclaimer',
      'zh-CN': '免责声明',
      ja: '免責事項',
    },
  },
  /** Note shown to non-English users below the title */
  englishNotice: {
    en: '',
    'zh-CN': '本文件以英文为准，英文版本具有法律效力。',
    ja: 'このドキュメントは英語で提供されます。英語版が法的拘束力を持ちます。',
  },
};
